import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { UserService } from '@app/user/services';
import { map } from 'rxjs/operators';
import { PATHS } from '@shared/constants/paths';

export function guestUserGuard(): CanActivateFn {
  return (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> => {
    const userService = inject(UserService);
    const router = inject(Router);
    return userService.isGuestUser$().pipe(
      map(isGuestUser => {
        if (isGuestUser) {
          const queryParams = { ...route.queryParams };
          const hasDeeplinks =
            'deeplink' in queryParams ||
            queryParams['originLinkType'] === 'PREFCENTER';

          if (!hasDeeplinks) {
            return router.parseUrl(PATHS.SEARCH_BROWSE);
          } else {
            return router.createUrlTree([PATHS.LOGIN], {
              queryParams: { returnUrl: state.url },
            });
          }
        } else {
          return true;
        }
      }),
    );
  };
}
